import Vue from 'vue'
import Router from 'vue-router'
import Footer from '@/components/footer'
import NotFound from '@/components/not-found'
import Welcome from '@/pages/welcome'
import Menu from '@/pages/menu'
import FundWallet from '@/pages/fund-wallet'
import Bill from '@/pages/bill'
import Payment from '@/pages/payment'
import Completed from '@/pages/completed'
import Sample from '@/pages/sample'
import js from '@/components/js'

Vue.use(Router)
Vue.component('Footer', Footer)
Vue.component('Welcome', Welcome)
Vue.component('Menu', Menu)
Vue.component('FundWallet', FundWallet)
Vue.component('Bill', Bill)
Vue.component('Completed', Completed)
Vue.component('Sample', Sample)
Vue.component('js', js)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {path: '/', redirect: '/revonue'},
    {
      path: '/revonue',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/revonue',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/revonue/sample',
      name: 'Sample',
      component: Sample
    },
    {
      path: '/revonue/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/revonue/fund-wallet',
      name: 'FundWallet',
      component: FundWallet
    },
    {
      path: '/revonue/bill',
      name: 'Bill',
      component: Bill
    },
    {
      path: '/revonue/payment',
      name: 'Payment',
      component: Payment
    },
    {
      path: '/revonue/completed',
      name: 'Completed',
      component: Completed
    },
    {
      path: '/revonue/not-found',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/revonue/not-found'
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js